<script>
  import { createEventDispatcher } from 'svelte';

  export let tabs;
  export let active;

  const dispatch = createEventDispatcher();

  function handleClick(item) {
    dispatch('change', item);
  }
</script>

<nav class="list-nav">
  <ul class="flexbox flexbox--full h-c">
    {#each tabs as tab}
      <li class="list-nav__item">
        <button
          class="list-nav__link tagline"
          class:active={active == tab.id}
          on:click={() => {
            handleClick(tab);
          }}
        >
          {tab.label}
        </button>
      </li>
    {/each}
  </ul>
</nav>

<style lang="scss">
  .list-nav {
    margin: 0 auto;
    max-width: 70rem;

    &__item {
      flex: 1;

      &:first-child {
        .list-nav__link {
          border-radius: 3rem 0 0 3rem;
        }
      }

      &:last-child {
        .list-nav__link {
          border-radius: 0 3rem 3rem 0;
        }
      }
    }

    &__link {
      position: relative;
      display: block;
      width: 100%;

      color: var(--royal-light);
      font-weight: 700;
      padding: 1.5rem;
      border: 1px solid $light-border;

      text-align: center;
      text-transform: uppercase;

      transition: all 0.25s;

      &::before {
        opacity: 0;
        content: '';
        position: absolute;
        left: 50%;
        top: 100%;

        width: 1.6rem;
        height: 1.6rem;

        margin-top: -0.8rem;

        transform: rotate(45deg);
        transition: all 0.25s;
      }

      &:hover {
        color: var(--royal);
      }

      &.active {
        color: rgb(var(--white));
        background-color: var(--royal);

        &::before {
          opacity: 1;
          background-color: var(--royal);
        }
      }
    }
  }
</style>
